import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QaiSimulationCardComponent } from '@qai/ui';
import { AuthorService } from 'src/app/services/self-serve/author.service';
import { ActivatedRoute } from '@angular/router';
import { SimulationConstants } from 'src/app/utils/constants/self-serve/simulation.constants';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { ISimulationUpdate } from 'src/app/interfaces/self-serve/requests/isimulation-update';
import { ISimulation } from 'src/app/interfaces/self-serve/responses/isimulation';
import { merge } from 'rxjs';
import { AuthorReactiveFormService } from 'src/app/pages/self-serve/simulation-builder/services/author-reactive-form.service';
import { IFetchSimulationDetails } from 'src/app/interfaces/self-serve/responses/ifetch-simulation-details';
import { PreviewSimulationDetailsModalComponent } from "../../../components/modals/preview-simulation-details/preview-simulation-modal.component";
import { ISimulationDetailInformationTab } from 'src/app/interfaces/self-serve/isimulation-details-information-tab';

@Component({
  selector: 'guided-simulation-information',
  standalone: true,
  templateUrl: './guided-simulation-information.component.html',
  styleUrls: ['./guided-simulation-information.component.scss'],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    QaiSimulationCardComponent,
    PreviewSimulationDetailsModalComponent,
  ],
})
export class GuidedSimulationInformationComponent {
  form!: FormGroup;
  callUuid: string = '';
  @Input() simulationDetails: IFetchSimulationDetails | null = null;

  simulationTabs!: FormGroup;
  openPreviewModal = false;
  previewTabs: { label: string; content: string }[] = [];
  previewModalButtonState: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private authorReactiveFormService: AuthorReactiveFormService
  ) {}

  ngOnInit(): void {
    this.callUuid = this.route.snapshot.paramMap.get('uuid')!;

    console.log('Simulation info', this.simulationDetails);

    this.authorReactiveFormService
      .getForm(this.callUuid)
      .pipe(take(1))
      .subscribe((form) => {
        this.form = form.get(
          SimulationConstants.SIMULATION_DETAILS_INFO_PATH
        ) as FormGroup;


        console.log('form', form);
        this.simulationTabs = this.form.get(
          'simulationDetailtabs'
        ) as FormGroup;

        const tabControls = Object.values(this.simulationTabs.controls);

        this.previewModalButtonState = !tabControls.some((control) => {
          const value = control.value;
          return value?.tabText && value.tabText.trim() !== '';
        });
      });
  }

  callDetailsClick(event: any) {
    this.previewModal();
  }

  previewModal() {
    const {
      simulationDetailtabs,
      additionalSectionTitle,
      additionalSectionInfo,
    } = this.form.value;
    const detailTabs = simulationDetailtabs.map(
      (tab: ISimulationDetailInformationTab) => ({
        label: tab.tabTitle,
        content: tab.tabText,
      })
    );

    if (additionalSectionTitle && additionalSectionInfo) {
      detailTabs.push({
        label: additionalSectionTitle,
        content: additionalSectionInfo,
      });
    }

    this.previewTabs = detailTabs;
    this.openPreviewModal = true;
  }

  handleModalClose() {
    this.openPreviewModal = false;
  }
}
